module.exports = __webpack_public_path__ + "static/media/Store-2022-cards-banner3a-SFW.902b1853.jpg";